export default [
  { id: "+45", title: "🇩🇰+45" },
  { id: "+46", title: "🇸🇪+46" },
  { id: "+47", title: "🇳🇴+47" },
  { id: "+48", title: "🇵🇱+48" },
  { id: "+358", title: "🇫🇮+358" },
];
